import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/system"

const Title = styled(Typography)({
  color: "rgb(85, 96, 100)",
  lineHeight: "42px",
  marginBottom: "32px",
})

const SubTitle = styled(Typography)({
  color: "rgb(85, 96, 100)",
  fontSize: "16px",
  lineHeight: "24px",
})

interface IEmptyState {
  title?: string
  subtitle?: string
  large?: boolean
}

export const EmptyState = (props: IEmptyState) => {
  const { title = "🤔", subtitle = "Nothing to see here.", large = false } = props

  return (
    <Box display="flex" mt={large ? 2 : 1} alignItems="center" flexDirection="column">
      <Title
        sx={{
          fontSize: large ? "72px" : "36px",
          paddingTop: large ? "125px" : 0,
        }}>
        {title}
      </Title>
      <SubTitle>{subtitle}</SubTitle>
    </Box>
  )
}
